import React, { useState } from "react";
import BOMTable2, {
  AvatarCell,
  SelectColumnFilter,
  StatusPill,
} from "./BOMTable2"; // new
import { useSelector, useDispatch } from "react-redux";
import { HiArrowCircleUp } from "react-icons/hi";
import { HiArrowCircleDown } from "react-icons/hi";
import { MdClear } from "react-icons/md";
import { setItemsSelected } from "../../../../../redux/slices/item/itemSlice";
import { useNavigate } from "react-router-dom";
import {getAuthorization} from "../../../../../axios/AxiosAut";

type Props = {
  HandleNext: () => void;
  HandleBack: () => void;
  ActiveStep: number;
};

function SelectedTableData(props: Props) {
  const Navigate = useNavigate();

  const [isSubmitting, setisSubmitting] = useState(false);
  const dispatch = useDispatch();
  const SelectedItems = useSelector((state) => state.item.ItemsSelected);
  const ProductID = useSelector((state) => state.product.ProductID);
  const DeleteRow = (value) => {
    const Index = value.row.index;
    const DataCopy = [...SelectedItems];
    DataCopy.splice(Index, 1);
    dispatch(setItemsSelected(DataCopy));
  };
  // const QuantityHandler = (e, index) => {
  //   const DataCopy = [...SelectedItems];
  //   let Object = DataCopy[index];
  //   let FinalObject = { ...Object, quantity: e.target.value };
  //   let FinalArray = [...FinalObject, FinalObject];
  //   // DataCopy[index].push({ quantity: e.target.value });
  //   console.log("Copy", FinalArray);
  // };
  const columns = React.useMemo(
    () => [
      {
        Header: "Item Name",
        accessor: "item.name",
        // Cell: StatusPill,
      },
      {
        Header: "Product ID",
        accessor: "item.product_id",
      },
      {
        Header: "Product Type",
        accessor: "item.product_type",
      },
      // {
      //   Header: "Quantity",
      //   Cell: (value) => (
      //     <div className="flex flex-row space-x-2">
      //       <input
      //         className="h-10 w-10 text-center text-sm text-blue-200 border-blue-200 border-2 rounded-md focus:border-blue-100"
      //         min={1}
      //         onChange={(e) => QuantityHandler(e, value.cell.row.index)}
      //         type="number"
      //       ></input>
      //     </div>
      //   ),
      // },
      {
        Header: "Remove Item",
        Cell: (value) => (
          <div className="flex flex-col ml-6">
            <button onClick={() => DeleteRow(value)}>
              <MdClear size={30} color="#D00000" />
            </button>
          </div>
        ),
      },
    ],
    [SelectedItems]
  );
  const onSubmit = () => {
    setisSubmitting(true);

    console.log("Submitted",  {bom_item: SelectedItems})
    getAuthorization()
      .post(`product/bom/${ProductID.id}/`, {
        name: ProductID.name,
        bom_item: SelectedItems,
      })
      .then((res) => {
        console.log("BOM success", res.data);
        props.HandleNext();
        setisSubmitting(false);
      })
      .catch((err) => {
        console.log("Error", err);
        setisSubmitting(false);
      });
  };
  return (
    <div className="">
      <main className="max-w-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="mt-3">
          <BOMTable2 columns={columns} data={SelectedItems} />
        </div>
      </main>
      <div className="flex items-center justify-center pt-8 sm:px-6 lg:px-8">
        <div className="w-full space-y-8">
          <div className="flex flex-row space-x-3 justify-center">
            <div className="flex flex-col w-3/5">
              <button
                onClick={() => Navigate("/dashboard/management/items")}
                type="button"
                className="border-2 border-red-700 hover:text-white text-base font-Montserrat font-bold text-red-700 flex-shrink hover:border-red-700 hover:bg-red-700 place-content-center rounded-md px-2 py-1 flex flex-grow w-40 "
              >
                Cancel
              </button>
            </div>
            <div className="flex flex-col w-1/5">
              {props.ActiveStep > 0 ? (
                <button
                  onClick={props.HandleBack}
                  type="button"
                  className="border-2 border-blue-200 hover:text-white text-base font-Montserrat font-bold text-blue-200 flex-shrink hover:border-blue-100 hover:bg-blue-100 place-content-center rounded-md px-2 py-1 flex flex-grow w-40 "
                >
                  Previous Step
                </button>
              ) : null}
            </div>
            <div className="flex flex-col w-1/5">
              {!isSubmitting ? (
                <button
                  onClick={onSubmit}
                  className="font-Montserrat font-semibold text-white bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1.5 flex flex-grow"
                >
                  Save
                </button>
              ) : (
                <button
                  disabled
                  className="font-Montserrat font-semibold text-white bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1.5 flex flex-grow"
                >
                  <div className="flex items-center justify-center space-x-2 animate-pulse">
                    <svg className="w-5 h-5 bg-green-50 rounded-full"></svg>
                    <svg className="w-5 h-5 bg-green-50 rounded-full"></svg>
                    <svg className="w-5 h-5 bg-green-50 rounded-full"></svg>
                  </div>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SelectedTableData;
